import React, { PropsWithChildren, useEffect, useState } from 'react';
import Container from '@/components/container';
import TabNav from '@/components/slide-menu/tab-nav';
import DetailHeaderInfoWrapper from '@/components/detail-header-info-wrapper';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import { getQuery } from '@/common/utils';
import roomApis from '@/apis/room/index';
import { message, Tooltip } from 'antd';
import { updateCrumbs } from '@/components/bread-crumbs';
import { CopyOutlined } from '@ant-design/icons';
import Copy from '@/components/copy';
import JdImg from '@/components/jd-img';
import { formateTimeStamp } from '@/common/utils';
import useHideBreadCrumbs from '@/components/bread-crumbs/use-hide-bread-crumbs';
// import BtnPowerManage from '../components/btn-authority-management';
import { useHistory } from 'react-router-dom';

function DailyActivitiesDetailsOperation(props: PropsWithChildren<any>) {
  const [dailyData, setDailyData] = useState<any | undefined>({});
  const [poolData, setPoolData] = useState<any | undefined>({});
  const [showHeader, setShowHeader] = useState(true);
  const [showNav, setShowNav] = useState(true);
  const [headerExtraProps, setHeaderExtraProps] = useState<any | undefined>({});
  const history = useHistory();
  const activityId = getQuery('activityId');
  const blockId = getQuery('blockId');

  const getExtra = () => {
    if (!!headerExtraProps.renderCrumbs) return [];
    if (blockId) {
      return [
        {
          key: '收品池编号',
          value: (
            <Copy key="blockId" text={blockId} icon={<CopyOutlined className="activity-card-detail__icon-copy" />} />
          ),
        },
        {
          key: '素材组编号',
          value: (
            <Copy
              key="otherSystemGroupId"
              text={poolData.otherSystemGroupId}
              icon={<CopyOutlined className="activity-card-detail__icon-copy" />}
            />
          ),
        },
        {
          key: '收品类型',
          value: poolData.gatherType,
        },
        {
          key: '示意图',
          value: !!poolData.imageUrl ? (
            <Tooltip
              key="image"
              overlayStyle={{ minWidth: 260 }}
              title={<JdImg className="venue_jd_img" src={poolData.imageUrl} width="100%" height={147} />}
            >
              <a>查看</a>
            </Tooltip>
          ) : (
            '-'
          ),
        },
        {
          key: '收品池介绍',
          value: poolData.description,
        },
      ];
    }
    return [
      {
        key: '管理组组长',
        value: dailyData.leader,
      },
      {
        key: '活动ID',
        value: activityId,
      },
      {
        key: '活动时间',
        value: `${formateTimeStamp(dailyData.startTime, true)} 至 ${formateTimeStamp(dailyData.endTime, true)}`,
      },
    ];
  };

  useEffect(() => {
    if (!activityId) {
      setDailyData({});
      return;
    }
    roomApis.getDetailByRoomId({ activityId }).then(({ ret, data, msg }: any = {}) => {
      if (ret === '0') {
        setDailyData(data);
      } else {
        message.error(msg);
      }
    });
  }, [activityId]);

  useEffect(() => {
    if (!activityId || !blockId) {
      setPoolData({});
      return;
    }
    roomApis
      .poolHeader({
        tibaoId: activityId,
        poolId: blockId,
      })
      .then(({ ret, msg, data }) => {
        if (ret === '0') {
          setPoolData(data);
        } else {
          message.error(msg);
        }
      });
  }, [activityId, blockId]);

  useEffect(() => {
    const data = {
      dailyData,
      poolData,
    };
    // 离开当前页面清除面包屑的数据
    return updateCrumbs(data);
  });

  useSlideMenuCollapse();
  useHideBreadCrumbs();
  const getStyle = () => (showNav ? {} : { style: { width: '100%' } });

  return (
    <ContextProviderMenus.Provider
      value={{
        children: props.children,
        setShowHeader,
        setShowNav,
        setHeaderExtraProps,
        roomId: dailyData.roomId,
        dailyData,
      }}
    >
      <Container bg={false} padding={false} margin={false}>
        {showHeader && (
          <DetailHeaderInfoWrapper
            extraInfo={getExtra()}
            onBack={() => {
              if (blockId || window.location.href.includes('poolSetting')) {
                history.push(
                  `/activity-manage/myCreate/daily-activities-operation?entry=${getQuery(
                    'entry'
                  )}&activityId=${activityId}&from=acore`
                );
              } else {
                history.push('/activity-manage/myCreate/room/activityReceipt');
              }
            }}
            {...headerExtraProps}
          />
        )}
        <div style={{ display: 'flex' }}>
          {showNav && <TabNav layout="vertical" sticky={true} />}
          <div className="venue__wrapper__right" {...getStyle()}>
            {props.children}
          </div>
        </div>
      </Container>
    </ContextProviderMenus.Provider>
  );
}

export default DailyActivitiesDetailsOperation;
